<template>
  <div class="product imgTOP-current contactUs-main header-90">
    <div class="top-img">
      <img src="../assets/images/contactfranchise1.jpg" alt="" class="mobile_hide">
      <img src="../assets/images/contactfranchise2-mobile.jpg" alt="" class="pc_hide">
      <div class="info-box">
        <div class="title-box">
          <h2>加盟合作</h2>
          <h3 v-if="$i18n.locale!='en'">{{ $t("home_4") }}</h3>
        </div>
      </div>
    </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="product-title">
          <router-link to="/home">{{ $t("home_0") }}</router-link>
          <em> / </em>
          <span>{{ $t("home_4") }} </span>
          <em> / </em>
          <span>{{ $t(curName) }} </span>
        </div>
        <div class="contactUs-nav mobile_hide" :class="{'en-nav-font':locale=='EN'}">
          <div class="nav-box">
            <div v-for="(item,index) in title" :key="index" class="title" :class="{active:curid == item.id}"
                 @click="tabid(item.id, item.name)">{{ $t(item.name) }}
            </div>
       
          </div>
        </div>
        <div class="type-nav pc_hide">          
          <vue-tab-select v-model="curid" v-bind:list="menuList" v-bind:title="'home_4'"
                          v-on:valueChanged="changeType"></vue-tab-select>
        </div>
        <div class="contactUs-show">
          <my-faq v-if="curid === 1"></my-faq>
          <my-join v-if="curid === 2"></my-join>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Faq from '../components/default/Franchise.vue';  // 店點提供
import Join from '../components/default/Join.vue';  //我要加盟
import Popup from '../components/default/Popup.vue';
import vueTabSelect from '../components/default/vue-tab-select';

export default {
  data() {
    return {
      curid: 1,
      curName: 'contact_75',
      title: [
        {name: 'contact_76', id: 1},
        {name: 'contact_75', id: 2},
      ],
      listall: [],
      list: [
        {
          id: 1,
          text: [
            {name: ''},
          ]
        },
        {
          id: 2,
          text: [
            {name: ''},

          ]
        },
      ],
      menuList: [
        {name: "contact_76", code: 1},
        {name: "contact_75", code: 2},


      ],
      locale:'tw'
    }
  },
    mounted() {
    const lang = sessionStorage.getItem('lang');

    if (lang) {
      this.locale = lang;
    }

    this.listall = this.list[0];

    if (this.$route.params.id) {
      this.changeType(this.$route.params.id);
    }
  },
  methods: {
    tabid(id, name) {
      this.curid = id;
      this.curName = name;
      this.list.forEach(el => {
        if (el.id == id) {
          this.listall = el;
        }
      })
    },
      changeType(value) {
      this.curid = Number(value);   // 確保是數字

      const choose = this.title.find(item => item.id === this.curid);

      if (choose) {
        this.tabid(choose.id, choose.name);
      }
    },

  },
  watch: {
    $route: {
      handler() {
        this.changeType(this.$route.params.id);
      },
      deep: true,
    }
  },
  components: {
    'my-faq': Faq,
    'my-join': Join,
    'my-popup': Popup,
    'vue-tab-select': vueTabSelect
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  padding-left: 0;
}

.product {
  width: 100%;
  height: auto;

 /* .top-img {
    width: 100%;
    height: 354px;
    position: relative;
    background: #f9f9f9 url("../assets/images/contactUs.png") no-repeat center;
    background-size: 100% 100%;

    .bg-img {
      position: absolute;
      width: 100%;
    }

    .info-box {
      width: 100%;
      max-width: 1130px;
      padding: 0 20px;
      margin: 0 auto;

      .title-box {
        float: left;
        padding-top: 60px;
        text-align: right;

        h2 {
          color: #FFFFFF;
          font-size: 70px;
          font-style: italic;
          font-weight: 900;
          letter-spacing: 0;
          line-height: 120px;
          margin: 0;
        }

        h3 {
          color: #FFFFFF;
          font-size: 36px;
          letter-spacing: 1px;
          line-height: 42px;
          margin: 0;
        }
      }
    }
  }*/

  .product-main {
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-contenBg2.png") no-repeat center 110px;
    overflow: hidden;
    padding-top: 50px;
    padding-bottom: 194px;
  }

  .product-conten {
    max-width: 1440px;
    margin: 0 auto;

    .product-title {
      padding-bottom: 50px;
      font-size: 14px;
      letter-spacing: 1.5px;
      text-align: left;
      padding-left: 29px;

      a {
        color: #000;
        text-decoration: underline;
      }

      em {
        padding: 0 4px;
      }

      span, em {
        color: #9A928D;
      }
    }
  }
}

.contactUs-nav {
  height: 80px;
  line-height: 80px;
  border-radius: 39px;
  background-color: #FFFFFF;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 68px;

  .nav-box {
    margin: 0 auto;
    text-align: center;

  }

  .title {
    // width: 25%;
    display: inline-block;
    cursor: pointer;
    font-size: 22px;
    //font-weight: 500;
    padding: 0 60px;
    letter-spacing:1px;

    a {
      color: inherit;
    }

  }

  .active , .title:hover{
    color: #D00717;
  }
}
.en-nav-font{
  .title{
    font-size: 20px;
    letter-spacing: 0;
  }
}
@media (max-width: 1080px) {
  .product {
    .product-main{
      padding: 0 20px;
      padding-bottom: 100px !important;
    }

    .product-conten {
      .product-title {
        padding-bottom: 30px;
        padding-left: 10px;
        font-size: 12px;
      }
    }
  }
  .type-nav{
    margin-bottom: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/contactfranchise.vue